export default class Timer {
    domTimerWrap;

    constructor() {
        for (const domTimer of document.querySelectorAll(".timer")) {
            if (domTimer.intervalId) {
                clearInterval(domTimer.intervalId);

                if (domTimer.parentElement) {
                    domTimer.parentElement.removeChild(domTimer);
                }
            }
        }

        if (!(this.domTimerWrap = document.querySelector(".timer"))) {
            return null;
        }

        if (this.domTimerWrap.parentElement !== document.body) {
            document.body.appendChild(this.domTimerWrap);
        }

        this.Timer();
    }

    getTime(deadline) {
        const time = deadline - Date.now();

        const domDays = this.domTimerWrap.querySelector(".days");
        const domHours = this.domTimerWrap.querySelector(".hours");
        const domMinutes = this.domTimerWrap.querySelector(".minutes");
        const domSeconds = this.domTimerWrap.querySelector(".seconds");

        if (time <= 0) {
            clearInterval(this.domTimerWrap.intervalId);

            domDays.innerHTML = 0;
            domHours.innerHTML = 0;
            domMinutes.innerHTML = 0;
            domSeconds.innerHTML = 0;
            return;
        }

        const days = Math.floor(time / (1000 * 60 * 60 * 24));
        const hours = Math.floor((time / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((time / 1000 / 60) % 60);
        const seconds = Math.floor((time / 1000) % 60);

        domDays.innerHTML = days;
        domHours.innerHTML = hours;
        domMinutes.innerHTML = minutes;
        domSeconds.innerHTML = seconds;
    }

    Timer() {
        const deadline = this.domTimerWrap.dataset.deadline;
        this.domTimerWrap.intervalId = setInterval(() => this.getTime(deadline), 1000);
        this.getTime(deadline);
    }
}
